import { useMemo } from "react";

import { isOffered, skillsForFocus } from "@/features/agents/skillsForFocus";
import { useActiveFirmSkills } from "@/features/firmKnowledge/hooks/useActiveFirmSkills";
import type { FirmSkillSummary } from "@/features/firmKnowledge/types";

import { useCaseVisa } from "../../useCaseVisa";

/** The firm's own automations this case offers, not hidden. */
export const useCaseAutomations = (): FirmSkillSummary[] => {
  const visa = useCaseVisa();
  const firmSkills = useActiveFirmSkills();
  return useMemo(
    () =>
      skillsForFocus(firmSkills, undefined, "case", visa || null).filter(
        (s) => !s.builtin && isOffered(s)
      ),
    [firmSkills, visa]
  );
};
